import BlogSection from "../components/home/BlogSection ";
import ContactSection from "../components/home/ContactSection";
import Hero from "../components/home/Hero";
import InfoCards from "../components/home/InfoCards";
import MeetTheTeam from "../components/home/MeetTheTeam";
import ProductsSection from "../components/home/ProductsSection";
import Testimonials from "../components/home/Testimonials";
import MachineGallery from "../components/home/whoweare/MachineGallery";
import WhoWeAre from "../components/home/whoweare/WhoWeAre";
import WorkTogether from "../components/home/WorkTogether";

function Home() {
  return (
    <div className="font-sans text-gray-800 bg-blue-200"> 
      <Hero />
      <InfoCards />
      <WhoWeAre />
      <ProductsSection />
      <MachineGallery />
      <MeetTheTeam />
      <Testimonials />
      <BlogSection />
      <ContactSection />
      
    </div>
  );
}

export default Home;
